import React from 'react';

/**
 * LoteTabObservaciones - Observaciones tab content
 */
const LoteTabObservaciones = ({ lote }) => {
    return (
        <div className="space-y-2">
            {/* Grid: Info de inspección + Sello */}
            <div className="grid grid-cols-2 gap-3">
                {/* Info de Inspección */}
                <div className="bg-gray-50 rounded p-3 border border-gray-200 flex flex-col justify-center">
                    <p className="text-xs text-gray-700 font-semibold mb-2">Información de Inspección</p>
                    <div className="space-y-2 text-xs">
                        <div>
                            <span className="text-gray-600 font-semibold">Inspector:</span>
                            <p className="text-gray-900 font-bold">{lote.inspeccion_inspector}</p>
                        </div>
                        <div>
                            <span className="text-gray-600 font-semibold">Fecha:</span>
                            <p className="text-gray-900 font-bold">{lote.inspeccion_fecha}</p>
                        </div>
                    </div>
                </div>

                {/* Sello */}
                <div className="flex items-center justify-center bg-gray-50 rounded p-3 border border-gray-200">
                    <img
                        src={lote.cert_digital ? '/web/sellos/inspeccion_virtual.png' : '/web/sellos/inspeccion_presencial.png'}
                        alt={lote.cert_digital ? 'Inspección Virtual' : 'Inspección Presencial'}
                        style={{ height: '150px' }}
                        className="object-contain"
                    />
                </div>
            </div>

            {/* Pesada - solo para vacunos/toros */}
            {lote.tipo_ganado !== 'L' && (
                <div className="bg-gray-50 rounded p-2 border border-gray-200">
                    <p className="text-xs text-gray-600 font-semibold mb-1">Pesada</p>
                    <p className="text-xs font-bold text-gray-900">{lote.pesada_tipo}</p>
                    <p className="text-xs text-gray-700">{lote.pesada_fecha}</p>
                </div>
            )}

            {/* Trazabilidad y Plazo */}
            <div className="grid grid-cols-2 gap-2">
                <div className="bg-blue-50 rounded p-2 border border-blue-200">
                    <p className="text-xs text-blue-800 font-semibold mb-1">Trazabilidad</p>
                    <p className="text-xs text-gray-900 font-bold">{lote.trazabilidad}</p>
                </div>
                <div className="bg-green-50 rounded p-2 border border-green-200">
                    <p className="text-xs text-green-800 font-semibold mb-1">Plazo</p>
                    <p className="text-xs text-gray-900 font-bold">{lote.plazo}</p>
                </div>
            </div>

            {/* Observaciones */}
            <div className="bg-yellow-50 rounded p-2 border border-yellow-200">
                <p className="text-xs text-yellow-800 font-semibold mb-1">Observaciones</p>
                <p className="text-xs text-gray-700 leading-relaxed">{lote.observaciones_detalladas}</p>
            </div>

            <div className="bg-yellow-50 rounded p-2 border border-yellow-200">
                <p className="text-xs text-yellow-800 font-semibold mb-1">Obs. Sanitarias</p>
                <p className="text-xs text-gray-900 font-medium">{lote.observaciones_sanitarias}</p>
            </div>
        </div>
    );
};

export default LoteTabObservaciones;
